const REQUEST_BASKETS_STATS = "REQUEST_BASKETS_STATS";
const RECEIVE_BASKETS_STATS = "RECEIVE_BASKETS_STATS";

export default {
    REQUEST_BASKETS_STATS, 
    RECEIVE_BASKETS_STATS, 
}